import { assoc, compose, dissoc, pick } from 'ramda'
import { capitalizeAllIfLower } from '@btime/helpers'
import { initLogger } from '@btime/logs-core'
import { useLoggedUser } from '@btime/react-session'

import { useSubdomain } from '../../contexts/UrlProvider'

const TOKEN = process.env.REACT_APP_LOG_TOKEN
const API_URL = process.env.REACT_APP_LOG_API_URL

const logger = initLogger(TOKEN, API_URL)

export const sendLog = logger.sendLog
export const sendFailedLog = logger.sendFailedLog
export const sendLogWithFallback = logger.sendLogWithFallback
export const sendLogFromCallResponse = logger.sendLogFromCallResponse
export const callWithLog = logger.callWithLog

export const useBtimeLogger = () => {
  const user = compose(
    pick(['id', 'name', 'email']), //
    item => assoc('name', capitalizeAllIfLower(item?.name || ''), item)
  )(useLoggedUser())
  const workspace = useSubdomain()

  const commonProps = { user, workspace }

  return {
    info: props => sendLogWithFallback({ level: 'info', ...commonProps, ...props }),
    error: props => sendLogWithFallback({ level: 'error', ...commonProps, ...props }),
    warn: props => sendLogWithFallback({ level: 'warn', ...commonProps, ...props }),
    monitor: props => sendLogWithFallback({ level: 'monitor', ...commonProps, ...props }),
    debug: props => sendLogWithFallback({ level: 'debug', ...commonProps, ...props }),
    call: (func, params, props = {}) => callWithLog(func, params, { ...commonProps, ...props }),
    monitorCall: (func, params, props = {}) =>
      callWithLog(func, params, { level: 'monitor', data: dissoc('response'), ...commonProps, ...props })
  }
}
